/** @format */

export const END_POINT = {
  AUTH: {
    LOGIN: "/login",
    LOGOUT: "/logout",
    ME: "/me",
    REFRESH_TOKEN: "/refresh",
  },
  ACTIVITIES: {
    LIST: "/activities",
  },
  MEMBERS: {
    LIST: "/users",
    SEARCH: "/users/search",
  },
  PROJECTS: {
    LIST: "/projects",
  },
  TAGS: {
    LIST: "/tags",
  },
  TASKS: {
    LIST: "/tasks",
    SEARCH: "/search",
  },
  ACCOUNT_CODES: {
    LIST: "/account-codes",
  },
  PAYMENT_VOUCHERS: {
    LIST: "/payment-vouchers",
  },
  PAYMENT_BANKINGS: {
    LIST: "/payment-bankings",
  },
  OPENING_BALANCE: {
    LIST: "/opening-balance",
  },
  BANK_ACCOUNTS: {
    LIST: "/bank-accounts",
  },
  COMPANIES: {
    LIST: "/companies",
  },
  RECEIPT_BANKINGS: {
    LIST: "/receipt-bankings",
  },
  CUSTOMERS: {
    LIST: "/customers",
  },
  DEPARTMENTS: {
    LIST: "/departments",
  },
  EMPLOYEES: {
    LIST: "/employees",
  },
  INVENTORIES: {
    LIST: "/inventories",
  },
  RECEIPTS: {
    LIST: "/receipts",
  },
  PURCHASE_ORDERS: {
    LIST: "/purchase-orders",
  },
  SALE_ORDERS: {
    LIST: "/sale-orders",
  },
  OTHER_ORDERS: {
    LIST: "/other-orders",
  },
  RETURN_ORDERS: {
    LIST: "/return-orders",
  },
  WMS_CODES: {
    LIST: "/wms-codes",
  },
  WMS_ITEM_GROUPS: {
    LIST: "/wms-item-groups",
  },
  WMS_ITEMS: {
    LIST: "/wms-items",
  },
  REPORTS: {
    S1A_HKD: "/reports/s1a-hkd",
    S2A_HKD: "/reports/s2a-hkd",
    S2B_HKD: "/reports/s2b-hkd",
    S2C_HKD: "/reports/s2c-hkd",
    S2D_HKD: "/reports/s2d-hkd",
    S2E_HKD: "/reports/s2e-hkd",
    S3A_HKD: "/reports/s3a-hkd",
    S4_HKD: "/reports/s4-hkd",
    S5_HKD: "/reports/s5-hkd",
    S6_HKD: "/reports/s6-hkd",
    S7_HKD: "/reports/s7-hkd",
    // Admin reports
    RP_IN_OUT:                    "/reports/rp-in-out",
    RP_ACCOUNT_RECEIVABLE:        "/reports/rp-account-receivable",
    RP_ACCOUNT_RECEIVABLE_DETAIL: "/reports/rp-account-receivable-detail",
    RP_DOWN_GTGT:                 "/reports/rp-down-gtgt",
    RP_HKD_STATE:                 "/reports/rp-hkd-state",
    RP_PURCHASE_DETAIL:           "/reports/rp-purchase-detail",
  },
};

export const headersFormData = {
  Accept: "application/json",
  "Content-Type": "multipart/form-data",
};
